import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import isEmpty from 'lodash.isempty';
import Cookies from 'js-cookie';

import Constants from '../../config/constants';
import logo from '../../../img/cc-logo-2022-white.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const ERROR_KEYS = {
	LOGIN_FAILED:
		'Unknown email address and/or password. Please check your credentials and try again.',
	USERNAME_EMAIL_REQUIRED: 'Email is required to log in',
	UNKNOWN: 'Unknown error - please contact support',
};

const Login = ({ user }) => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [rememberMe, setRememberMe] = useState(false);
	const [isLoggingIn, setLoggingIn] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [errorKey, setErrorKey] = useState('');
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const email = Cookies.get(Constants.CCPUSERNAME);
		if (email) {
			user.set({
				email: email,
				rememberMe: true,
			});
			setEmail(email);
			setRememberMe(true);
		} else {
			user.set({
				rememberMe: false,
			});
		}
	}, []);

	const handleEmail = ({ target }) => {
		setEmail(target.value);
	};

	const handlePassword = ({ target }) => {
		setPassword(target.value);
	};

	const handleRememberMe = () => {
		setRememberMe(!rememberMe);
	};

	const handleLogin = (event) => {
		event.preventDefault();
		let from = location.state?.from?.pathname || '/';
		user.set({ email, password, rememberMe });

		setLoggingIn(true);
		setHasError(false);
		setErrorKey('');

		user
			.login()
			.then(() => {
				if (user.get('password_reset_required')) {
					from = '/fpc';
				} else if (from === '/' && user.get('portal_start_page')) {
					from = `/${user.get('portal_start_page')}`;
				}
				navigate(from, { replace: true });
			})
			.fail((response) => {
				let errorKey;
				if (response.responseJSON && response.responseJSON.error) {
					errorKey = response.responseJSON.error;
				} else if (response.statusText === 'error') {
					errorKey = response.statusText;
				}
				setLoggingIn(false);
				setHasError(true);
				setErrorKey(errorKey);
			});
	};

	const spinnerClasses = classNames('fa', 'fa-spin', 'fa-spinner', {
		hidden: !isLoggingIn,
	});
	const alertClasses = classNames('alert', 'alert-danger', {
		hidden: !hasError,
	});

	let errorMessage;
	if (errorKey?.code && ERROR_KEYS[errorKey.code]) {
		errorMessage = ERROR_KEYS[errorKey.code];
	} else {
		errorMessage = ERROR_KEYS.UNKNOWN;
	}

	return (
		<div className="main block-center mt-xl wd-xl">
			<div className="panel panel-dark panel-flat">
				<div className="panel-heading text-center">
					<Link to="/">
						<img src={logo} />
					</Link>
				</div>
				<div className="panel-body">
					<form className="mb-lg" onSubmit={handleLogin}>
						<h4 className="text-center">Provider Login</h4>
						<p className="text-center pv">Please sign in to continue</p>
						<div role="alert" className={alertClasses}>
							{errorMessage}
						</div>
						<div className="form-group has-feedback">
							<label htmlFor="inputEmail" className="sr-only">
								Email address
							</label>
							<input
								type="email"
								className="form-control email"
								placeholder="Email address"
								required="required"
								autoFocus
								autoComplete="off"
								value={email}
								onChange={handleEmail}
							/>
							<span className="fa fa-envelope form-control-feedback text-muted"></span>
						</div>
						<div className="form-group has-feedback">
							<label htmlFor="inputPassword" className="sr-only">
								Password
							</label>
							<input
								type="password"
								className="form-control password"
								placeholder="Password"
								required="required"
								autoComplete="off"
								onChange={handlePassword}
								value={password}
							/>
							<span className="fa fa-lock form-control-feedback text-muted"></span>
						</div>
						<div className="clearfix">
							<div className="checkbox c-checkbox pull-left mt0">
								<label>
									<input
										type="checkbox"
										name="remember"
										checked={rememberMe}
										onChange={handleRememberMe}
									/>
									<span className="fa fa-check"></span>Remember Me
								</label>
							</div>
							<div className="pull-right">
								<Link to="/forgot-password">Forgot your password?</Link>
							</div>
						</div>
						<button className="btn btn-lg btn-primary btn-block sign-in mt-lg">
							<span className={spinnerClasses}></span> Sign in
						</button>
					</form>
					<div className="mb-lg">
						<a
							className="btn btn-default btn-block"
							href="https://careconvenekb.helpsite.com/"
							target="_blank"
							rel="noreferrer"
						>
							Getting Started
						</a>
					</div>
					<p className="text-center mb0">
						<small>&copy; 2023 CareConvene, version PACKAGE_VERSION</small>
					</p>
				</div>
			</div>
		</div>
	);
};

Login.propTypes = {
	user: PropTypes.object.isRequired,
};

export default Login;
